export const genbillActionTypes= {
    HANDLE_GENBILL_NAV:"HANDLE_GENBILL_NAV",
    SHOW_SUMMARY_DRAWER:"SHOW_SUMMARY_DRAWER",
    CLEAR_SORT_TOGGLE:"CLEAR_SORT_TOGGLE",
    SET_CLIENT_VIEW:"SET_CLIENT_VIEW"     
}